import { toHtml } from './to-html';
import { toStateJson } from './to-state-json';
import { fromStateJson, addFromStateJson } from './from-state-json';
import { addComponent } from './add-component';

export default {
  toHtml,
  toStateJson,
  fromStateJson,
  addFromStateJson,
  addComponent
};
